import { ReactNode, useLayoutEffect } from 'react'
import {
  BANNER_HEIGHT,
  CampaignBanner,
} from 'src/features/campaignBanner/CampaignBanner'
import { useCampaignBannerDismissal } from 'src/features/campaignBanner/campaignBannerDismissal'
import { Campaign } from 'src/features/campaignBanner/parseCampaigns'
import { useQueryCampaigns } from 'src/features/campaignBanner/useQueryCampaigns'

/**
 * 各画面が `calc(100vh - var(--banner-height, 0px))` の形で高さを計算するために参照する。
 */
const BANNER_HEIGHT_CSS_VAR = '--banner-height'

/**
 * 掲載中のキャンペーンがあれば、children の上にバナーを表示する。
 *
 * 掲載するかどうかはキャンペーン配信 API が決めるため、フロント側に掲載期間や
 * キャンペーンごとの設定は持たない。取得できなかった場合はバナーを出さない。
 */
export const CampaignBannerWrapper = (props: { children: ReactNode }) => {
  const { children } = props

  const { data: campaign } = useQueryCampaigns()

  return (
    <>
      {campaign && <CampaignBannerArea campaign={campaign} />}
      {children}
    </>
  )
}

/**
 * 閉じられている場合は何も描画しない。
 */
const CampaignBannerArea = (props: { campaign: Campaign }) => {
  const { campaign } = props

  const { isDismissed, dismiss } = useCampaignBannerDismissal(
    campaign.campaignId,
  )

  // バナーのぶんだけ各画面が高さを差し引けるようにする（描画前に反映する）
  useLayoutEffect(() => {
    if (isDismissed) return

    const root = document.documentElement
    root.style.setProperty(BANNER_HEIGHT_CSS_VAR, `${BANNER_HEIGHT}px`)

    return () => {
      root.style.removeProperty(BANNER_HEIGHT_CSS_VAR)
    }
  }, [isDismissed])

  if (isDismissed) return null

  return <CampaignBanner campaign={campaign} onClose={dismiss} />
}
